import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import Colors from "../../../../../global/Colors";
import FullyRoundedButton from "../../../../../ui library/components/buttons/FullyRoundedButton";
import Svg, { SvgEnum } from "../../../../../ui library/components/svgs/standard/svg";
import CircularGradientProgressBar from "../../../../../ui library/dataVisualizations/ProgressBarCircularGradient";
import HNSColors from "../../../../../ui library/HNSColors";
import KPIUnavailable from "../../../../../ui library/icons/KPIUnavailable";
import STRINGS from "../../utils/strings";

import MetricInfo from "./MetricInfo";

export default function CustomAccordionDetails({ accordionItemContent }) {
  const navigate = useNavigate();
  const data = accordionItemContent?.data ?? null;
  const title = data?.title ?? STRINGS.defaultTitle;
  const percentageInfo = data?.percentageScore ?? "";
  const percent = percentageInfo.value ?? 0;
  const performanceText = data?.performanceText ?? "";
  const percentageLabel = percentageInfo?.label ?? "";
  const percentagePerformanceText = percentageInfo?.performanceText ?? "";
  const summaryText = data?.summary ?? "";
  const kpiData = data?.cells ?? [];

  return data ? (
    <div className="flex flex-col gap-2 px-4">
      <Typography className="text-3xl text-blue-700">
        <span className="font-bold text-black">
          {title}
          {", "}
        </span>
        <span>{performanceText}</span>
      </Typography>
      <div className="flex h-[40%] w-full flex-row items-center justify-evenly gap-6 px-6">
        <CircularGradientProgressBar
          progressPercent={percent}
          trackWidth={1.5}
          height={325}
          width={325}
          gradientColors={STRINGS.gradientColors}
        >
          <div className="text-center">
            <Typography className="text-[4px] font-semibold text-black">
              {percentageLabel}
            </Typography>
            <div className="mx-auto max-w-[60px] break-words">
              <Typography className="text-[5px] font-normal leading-tight text-blue-700">
                {percentagePerformanceText}
              </Typography>
            </div>
          </div>
        </CircularGradientProgressBar>
        <div className="flex flex-1 flex-col gap-6 px-2">
          <div className="flex flex-row items-center gap-4">
            <Svg
              name={SvgEnum.HisAlertCircle}
              color={HNSColors.primary[500]}
              sx={{
                height: "24px",
                width: "24px",
              }}
            />
            <div>
              <Typography>
                <span className="font-semibold">{"Action Required: "}</span>
                <span
                  style={{
                    color: HNSColors.neutrals[400],
                  }}
                >
                  {summaryText}
                </span>
              </Typography>
            </div>
          </div>

          <div className="m-0 grid max-w-[100%] grid-cols-3 gap-6 bg-white px-0">
            {kpiData && kpiData.map((item) => <MetricInfo item={item} />)}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="flex flex-col gap-4 px-2">
      <Typography className="text-3xl text-black">
        <span className="font-bold text-black">
          {"No KPIs Available"}
          {" - "}
        </span>
        <span>{"No Team Assigned"}</span>
      </Typography>
      <div className="flex h-fit flex-col items-center justify-center gap-2 rounded-lg bg-sky-100 p-8">
        <KPIUnavailable />
        <Typography className="text-center text-3xl text-blue-700">
          <span className="font-semibold">You’re not currently assigned to a team</span>, so your
          KPIs are not showing up.
        </Typography>
        <Typography className="text-center text-lg text-black">
          Please reach out to your team lead to get added to a team. Once you’re listed, your KPIs
          will be available here.
        </Typography>
        <div className="w-[20%] text-center">
          <FullyRoundedButton
            buttonWidth="w-full"
            buttonHeight="h-10"
            buttonText="View Cases"
            bgColor="bg-violet-800"
            hoverBgColor={Colors.violet[900]}
            handleOnClick={() => {
              navigate(STRINGS.navigationPaths.SEARCH);
            }}
          />
        </div>
      </div>
    </div>
  );
}
